<div class="task-assignee row">
  <circ-person-from-login
  [class.inactive]="assignee.result"
  [login]="assignee.user.login"
  [showLogin]="false"
  [showImage]="showImage"
  [showName]="showName"
  ></circ-person-from-login>

  <div
  *ngIf="assignee.result == 'Forwarded'"
  title="{{'task.detail.hover.title.forwarded' | i18n}}: {{assignee.comment}}"
  class="k-icon k-i-redo" [class.inactive]="assignee.result">
  <kendo-icon name="redo" themeColor="primary"></kendo-icon>
</div>
</div>
